// extracted by mini-css-extract-plugin
module.exports = {"divider":"Divider_divider__CnigX","divider-animate":"Divider_divider-animate__3T0eU","slideInFromLeft":"Divider_slideInFromLeft__3nPl0"};